/**
 * 2019-11-04
 * handan
 * 获取浏览器内核名称以及版本号
 */

class BrowserCore{

  getBrowserCoreInfo(){
    var nAgt = navigator.userAgent;
    var bcName = ""; // 浏览器名称，默认值
    var bcVersion = ''; // 浏览器版本，默认值
    var verOffset = "";
    var ix = "" ;
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) { // In Opera, the true bcVersion is after "Opera" or after "bcVersion"
      bcName = "Opera";
      bcVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf("bcVersion")) !== -1){
        bcVersion = nAgt.substring(verOffset + 8);
      }
    }
    else if ((nAgt.indexOf("Trident")) !== -1) {   // ( ver >= ie7) In MSIE, the true bcVersion is after "MSIE" in userAgent
      if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        bcVersion = nAgt.substring(verOffset + 5);
      } else {
        bcVersion = '11.0';
      }
      if (bcVersion === 5) {
        bcVersion = "11.0";
      }
      bcName = "IE";
    }
    else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {  // In Chrome, the true bcVersion is after "Chrome"
      bcName = "Chrome";
      bcVersion = nAgt.substring(verOffset + 7);
    }
    else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {   // In Safari, the true bcVersion is after "Safari" or after "bcVersion"
      bcName = "Safari";
      bcVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf("bcVersion")) !== -1)
        bcVersion = nAgt.substring(verOffset + 8);
    }
    else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {    // In Firefox, the true bcVersion is after "Firefox"
      bcName = "Firefox";
      bcVersion = nAgt.substring(verOffset + 8);
    }
    else if ((verOffset = nAgt.indexOf("Netscape")) !== -1) {    // In Netscape, the true bcVersion is after "Netscape"
      bcName = "Netscape";
      bcVersion = nAgt.substring(verOffset + 9);
    }

    if ((ix = bcVersion.indexOf(";")) !== -1){     // trim the bcVersion string at semicolon/space if present
      bcVersion = bcVersion.substring(0, ix);
    }        
    if ((ix = bcVersion.indexOf(" ")) !== -1){
      bcVersion = bcVersion.substring(0, ix);
    }

    return {
      bcName: bcName || "其它" ,
      bcVersion: bcVersion || "未知" ,
    }
  }
}

export default new BrowserCore() ;